/**
 * Simplified Dutch Inheritance Tax Calculator Logic
 * Based on 2024/2025 indicative brackets and exemptions.
 */
export const calculateTax = (data) => {
  const amount = parseFloat(data.estateValue) || 0;
  const relation = data.relation;
  const numChildren = parseInt(data.numChildren) || 1;

  let exemption = 0;
  let rate1 = 0.10;
  let rate2 = 0.20;
  let bracket = 152575;

  // Set parameters based on relation
  switch (relation) {
    case 'Partner':
      exemption = 795156;
      break;
    case 'Kind':
      exemption = 25187;
      break;
    case 'Kleinkind':
      exemption = 25187;
      rate1 = 0.18;
      rate2 = 0.36;
      break;
    default: // Overig
      exemption = 2658;
      rate1 = 0.30;
      rate2 = 0.40;
  }

  const taxableAmount = Math.max(0, amount - exemption);
  let totalTax = 0;

  if (taxableAmount > 0) {
    if (taxableAmount <= bracket) {
      totalTax = taxableAmount * rate1;
    } else {
      totalTax = (bracket * rate1) + ((taxableAmount - bracket) * rate2);
    }
  }

  // Adjust for number of children if Kind is selected
  if (relation === 'Kind') {
    // In a real scenario, this is per child. We show a range.
    totalTax = totalTax * numChildren;
  }

  return {
    tax: totalTax,
    taxable: taxableAmount,
    exemption: exemption,
    range: {
      min: totalTax * 0.95,
      max: totalTax * 1.15
    }
  };
};

export const getInsights = (data) => {
  const insights = [];
  
  if (data.testament === 'Nee' && data.numChildren > 0) {
    insights.push({
      title: 'Wettelijke Verdeling',
      desc: 'Zonder testament bepaalt de wet de verdeling. Dit kan leiden tot onbedoelde claim-rechten van kinderen op de langstlevende partner.',
      type: 'warning'
    });
  }

  if (data.business === 'Ja') {
    insights.push({
      title: 'Bedrijfsopvolgingsregeling (BOR)',
      desc: 'Uw ondernemingsvermogen komt mogelijk in aanmerking voor grote vrijstellingen (tot €1,3mln). Dit vereist echter een specifieke testamentaire structuur.',
      type: 'info'
    });
  }

  if (data.international === 'Ja') {
    insights.push({
      title: 'Internationaal Recht',
      desc: 'Bezit in het buitenland kan leiden tot dubbele belastingheffing. Een rechtskeuze in uw testament is essentieel.',
      type: 'critical'
    });
  }

  if (data.blended === 'Ja') {
    insights.push({
      title: 'Stiefkinderen',
      desc: 'In een samengesteld gezin erven stiefkinderen niet automatisch. Zonder testament worden zij overgeslagen in de verdeling.',
      type: 'warning'
    });
  }

  if (data.estateValue > 500000 && data.testament !== 'Ja') {
    insights.push({
      title: 'Fiscale Optimalisatie',
      desc: 'Bij een vermogen boven de €500k zijn technieken zoals tweetrapstestamenten of opvullegaat zeer effectief om belasting te besparen.',
      type: 'info'
    });
  }

  return insights;
};